<script setup lang="ts">
import type { CampaignOperationMgr } from "~/modules/campaign/models/CampaignOperationMgr.interface";

defineProps<{
  campaign?: CampaignOperationMgr;
}>();

const { t } = useI18n();

const operationsTotalCount = ref();
const onComputeTotalCount = (totalCount: number) => {
  operationsTotalCount.value = totalCount;
};
</script>
<template>
  <lxc-card>
    <h5>
      {{ t("campaign.details.status.title") }}
      <campaign-operation-mgr-status-badge
        v-if="campaign"
        class="ml-2"
        :status="campaign.status!"
      />
    </h5>
    <h6 class="!mb-4">
      {{
        t(
          "campaign.details.characteristics.equipments.statistics.title",
          operationsTotalCount ?? 0,
        )
      }}
    </h6>
    <campaign-pie
      class="h-60"
      :campaign-operation-mgr="campaign"
      @total-count-computation="onComputeTotalCount"
    />
  </lxc-card>
</template>
